module.exports = "pegasus/assets/background-patterns/default-pets-theme.jpg";